export { default as LoginForm } from "./LoginForm";
export { default as LoginForm2 } from "./LoginForm2";
export { default as RegisterForm } from "./RegisterForm";
export { default as RegisterForm2 } from "./RegisterForm2";
export { default as ResetPasswordForm } from "./ResetPasswordForm";
export { default as ForgotPasswordForm } from "./ForgotPasswordForm";
export { default as ForgotPasswordForm2 } from "./ForgotPasswordForm2";
export { default as ChangePasswordForm } from "./ChangePasswordForm";
export { default as UserProfileForm } from "./UserProfileForm";
export { default as MobileVerificationForm } from "./ValidateMobileForm";
